validateOptions